// 12 Pilgrim Services mirrored from ttdevasthanams.ap.gov.in
export const SERVICES = [
  {
    id: "special-entry-darshan",
    name: "Special Entry Darshan (₹300)",
    short: "Special Entry Darshan",
    icon: "Ticket",
    amount: 300,
    desc: "Rs.300 Special Entry Darshan tickets for Srivari Temple, Tirumala.",
    slots: ["06:00 - 08:00 AM", "09:00 - 11:00 AM", "12:00 - 02:00 PM", "03:00 - 05:00 PM", "06:00 - 08:00 PM"],
    color: "#E65100",
  },
  {
    id: "arjitha-seva",
    name: "Arjitha Sevas",
    short: "Arjitha Sevas",
    icon: "Flame",
    amount: 1500,
    desc: "Kalyanam, Unjal Seva, Arjitha Brahmotsavam & Sahasra Deepalankara Seva.",
    slots: ["Morning", "Afternoon", "Evening"],
    color: "#BF360C",
  },
  {
    id: "seva-edip",
    name: "Seva E-Dip",
    short: "Seva E-Dip",
    icon: "ScrollText",
    amount: 0,
    desc: "Electronic DIP registration for Srivari Arjitha Sevas lucky dip.",
    slots: null,
    color: "#7A0016",
    hidden: true,
  },
  {
    id: "accommodation",
    name: "Accommodation — Sri Venkateswara Guest House",
    short: "Accommodation",
    icon: "BedDouble",
    amount: 1000,
    desc: "Sri Venkateswara Guest House, Tirumala. Check-in 2:00 PM, Check-out 1:00 PM. Minimum 3 persons per room.",
    slots: null,
    roomTypes: [
      { name: "AC Deluxe Room", amount: 1200 },
      { name: "Non-AC Deluxe Room", amount: 1000 },
    ],
    checkIn: "02:00 PM",
    checkOut: "01:00 PM",
    minPersons: 3,
    location: "Sri Venkateswara Guest House, Tirumala Temple, Tirumala, Tirupati Urban, Andhra Pradesh 517504",
    color: "#DAA520",
  },
  {
    id: "angapradakshinam",
    name: "Angapradakshinam",
    short: "Angapradakshinam",
    icon: "Footprints",
    amount: 500,
    desc: "Tirumala Angapradakshinam tokens inside the temple premises.",
    slots: ["Early Morning"],
    color: "#E65100",
  },
  {
    id: "online-seva",
    name: "Online Sevas (Virtual)",
    short: "Online Sevas",
    icon: "MonitorPlay",
    amount: 750,
    desc: "Virtual participation in Kalyanotsavam, Unjal Seva & more.",
    slots: ["Morning", "Evening"],
    color: "#BF360C",
  },
  {
    id: "divyanugraha-homam",
    name: "Sri Srinivasa Divyanugraha Homam",
    short: "Divyanugraha Homam",
    icon: "Sparkles",
    amount: 5000,
    desc: "Visesha Homam at Saptha Gau Pradhakshina shala, Alipiri.",
    slots: ["06:00 AM", "10:00 AM"],
    color: "#7A0016",
  },
  {
    id: "swamyvari-hundi",
    name: "Swamyvari (e-Hundi)",
    short: "Swamyvari e-Hundi",
    icon: "HandCoins",
    amount: 0,
    customAmount: true,
    desc: "Offer your donation to Lord Venkateswara through e-Hundi.",
    slots: null,
    color: "#DAA520",
    hidden: true,
  },
  {
    id: "ammavari-hundi",
    name: "Ammavari (e-Hundi)",
    short: "Ammavari e-Hundi",
    icon: "HandCoins",
    amount: 0,
    customAmount: true,
    desc: "Offer your donation to Sri Padmavathi Ammavari through e-Hundi.",
    slots: null,
    color: "#E65100",
  },
  {
    id: "srivani-trust",
    name: "SRIVANI Trust Donation",
    short: "SRIVANI Trust",
    icon: "Gift",
    amount: 10000,
    customAmount: true,
    desc: "Sri Venkateswara Nitya Annadanam & other trust donations.",
    slots: null,
    color: "#BF360C",
  },
  {
    id: "kalyanamandapam",
    name: "Kalyanamandapam",
    short: "Kalyanamandapam",
    icon: "Building2",
    amount: 10000,
    desc: "Book TTD Kalyanamandapam for auspicious functions.",
    slots: ["Full Day", "Half Day"],
    color: "#7A0016",
  },
  {
    id: "srivari-seva",
    name: "Srivari Seva (Volunteer)",
    short: "Srivari Seva",
    icon: "HeartHandshake",
    amount: 0,
    desc: "Register as a Srivari Sevak volunteer at Tirumala / Tirupati.",
    slots: ["Same day reporting"],
    color: "#DAA520",
    hidden: true,
  },
  {
    id: "vip-darshan",
    name: "VIP Darshan (₹500)",
    short: "VIP Darshan",
    icon: "Crown",
    amount: 500,
    desc: "Priority VIP Darshan of Lord Venkateswara, Tirumala.",
    slots: ["10:00 AM", "12:00 PM", "02:00 PM", "04:00 PM", "05:00 PM"],
    color: "#BF360C",
  },
  {
    id: "suprabhatha-seva",
    name: "Suprabhatha Seva (Morning Wake-up)",
    short: "Suprabhatha Seva",
    icon: "Sunrise",
    amount: 2000,
    desc: "The morning wake-up ritual of Srivari, per person.",
    slots: ["03:00 AM"],
    color: "#E65100",
  },
  {
    id: "thomala-archana-seva",
    name: "Thomala / Archana Seva",
    short: "Thomala / Archana",
    icon: "Flower2",
    amount: 1600,
    desc: "Garland offering & Archana Seva to the deity, per person.",
    slots: ["03:30 AM", "04:30 AM"],
    color: "#7A0016",
  },
  {
    id: "kalyanotsavam",
    name: "Kalyanotsavam (Marriage Seva)",
    short: "Kalyanotsavam",
    icon: "Gem",
    amount: 2000,
    desc: "Celestial wedding seva of Srivari & Ammavaru, per couple.",
    slots: ["11:00 AM"],
    color: "#DAA520",
  },
  {
    id: "sahasra-deepalankarana",
    name: "Sahasra Deepalankarana Seva",
    short: "Sahasra Deepalankarana",
    icon: "Flame",
    amount: 1600,
    desc: "Thousand-lamp illumination seva, per person.",
    slots: ["05:00 PM"],
    color: "#E65100",
  },
  {
    id: "vip-break-darshan",
    name: "VIP Break Darshan (Srivani Seva)",
    short: "VIP Break Darshan",
    icon: "Sparkles",
    amount: 10500,
    desc: "Srivani Trust VIP break darshan, per person.",
    slots: ["04:00 AM", "04:00 PM"],
    color: "#BF360C",
  },
];

export const STATUS_META = {
  awaiting_payment: { label: "Awaiting Payment", color: "bg-amber-100 text-amber-800 border-amber-300" },
  pending: { label: "Pending Approval", color: "bg-orange-100 text-orange-800 border-orange-300" },
  confirmed: { label: "Confirmed", color: "bg-green-100 text-green-800 border-green-300" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-800 border-red-300" },
};

export const UPDATES = [
  "Srivari Arjitha Sevas Electronic DIP Registrations for January-2027 available w.e.f 19.10.2026, 10:00 AM.",
  "Special Entry Darshan (Rs.300) tickets for January-2027 available for booking w.e.f. 24.10.2026, 10:00 AM.",
  "Tirumala & Tirupati Accommodation Quota for January-2027 available w.e.f. 24.10.2026, 03:00 PM.",
  "Tirumala Angapradakshinam tokens for January-2027 available w.e.f. 23.10.2026, 10:00 AM.",
  "Senior Citizens / Physically challenged quota for January-2027 available w.e.f. 23.10.2026, 3:00 PM.",
];
